// src/data/m10/index.js

import { M10_UNIT_1 } from './Unit1';
import { M10_UNIT_2 } from './Unit2';
import { M10_UNIT_3 } from './Unit3';
import { M10_UNIT_4 } from './Unit4';
import { M10_UNIT_5 } from './Unit5';
import { M10_UNIT_6 } from './Unit6';
import { M10_UNIT_7 } from './Unit7';
import { M10_UNIT_8 } from './Unit8';
import { M10_UNIT_9 } from './Unit9';
import { M10_UNIT_10 } from './Unit10';
import { M10_UNIT_11 } from './Unit11';
import { M10_UNIT_12 } from './Unit12';
import { M10_UNIT_13 } from './Unit13';
import { M10_UNIT_14 } from './Unit14';
import { M10_UNIT_15 } from './Unit15';
import { M10_READING_PRACTICE } from './ReadingPractice';
import { M10_MODULE_REVIEW } from './UnitReview';
export const MODULE_10_UNITS = [
  M10_UNIT_1,
  M10_UNIT_2,
  M10_UNIT_3,
  M10_UNIT_4,
  M10_UNIT_5,
  M10_UNIT_6,
  M10_UNIT_7,
  M10_UNIT_8,
  M10_UNIT_9,
  M10_UNIT_10,
  M10_UNIT_11,
  M10_UNIT_12,
  M10_UNIT_13,
  M10_UNIT_14,
  M10_UNIT_15,
  M10_READING_PRACTICE,
  M10_MODULE_REVIEW
];